import PropTypes from "prop-types";
import { Navigate, useLocation } from "react-router-dom";

import { getRoutePermissions } from "utils/getRoutePermissions";
import useAuth from "hooks/useAuth";

const PermissionGuard = ({ children }) => {
  const location = useLocation();
  const { systemUserRoles } = useAuth();

  const requiredPermissions = getRoutePermissions(location.pathname + location.search);
  if (!requiredPermissions || requiredPermissions.length === 0) return children;

  const hasPermission = requiredPermissions.some((p) => systemUserRoles.includes(p));

  if (!hasPermission) {
    return <Navigate replace to="/dashboard" />;
  }

  return children;
};

PermissionGuard.propTypes = {
  children: PropTypes.node,
};

export default PermissionGuard;
